import React, { useState } from 'react'
import {
  Modal,
  Box,
  TextField,
  Button,
  MenuItem,
  Typography,
} from '@mui/material'
import Axios from 'axios'
import { Notyf } from 'notyf'
import server from '../variables'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
}

const GenerateBillModal = ({ show, handleClose, schemeID }) => {
  const notyf = new Notyf()

  const [month, setMonth] = useState('')
  const [year, setYear] = useState('')
  const [tariff, setTariff] = useState('')
  const [billDate, setBillDate] = useState(
    new Date().toISOString().split('T')[0] // 👈 default = today
  )
  const [loading, setLoading] = useState(false)

  const handleGenerateBill = async () => {
    if (!month || !year || !tariff || !billDate) {
      notyf.error('Please select Month, Year, Tariff and Bill Date')
      return
    }

    try {
      setLoading(true)

      const { data } = await Axios.post(
        server + 'admin/generate-bills',
        {
          schemeID,
          month,
          year,
          tariff,
          billDate, // 👈 NEW FIELD
        },
        {
          headers: { authorization: localStorage.getItem('token') },
        }
      )

      setLoading(false)

      if (data.status === 200) {
        notyf.success('Bill generated successfully!')
        handleClose()
      } else {
        notyf.error(data.message || 'Failed to generate bill')
      }
    } catch (err) {
      console.log(err)
      notyf.error('Internal server error')
      setLoading(false)
    }
  }

  return (
    <Modal open={show} onClose={handleClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2} textAlign="center">
          Generate Bill
        </Typography>

        {/* MONTH */}
        <TextField
          select
          label="Month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          fullWidth
          size="small"
          margin="normal"
        >
          {[
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ].map((m, i) => (
            <MenuItem key={i + 1} value={m}>
              {m}
            </MenuItem>
          ))}
        </TextField>

        {/* YEAR */}
        <TextField
          label="Year"
          type="number"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          fullWidth
          size="small"
          margin="normal"
          inputProps={{ min: 2000 }}
        />

        {/* BILL DATE */}
        <TextField
          label="Bill Date"
          type="date"
          value={billDate}
          onChange={(e) => setBillDate(e.target.value)}
          fullWidth
          size="small"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        />

        {/* TARIFF */}
        <TextField
          label="Tariff"
          type="number"
          value={tariff}
          onChange={(e) => setTariff(e.target.value)}
          fullWidth
          size="small"
          margin="normal"
        />

        {/* ACTION BUTTONS */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1,
            mt: 2,
          }}
        >
          <Button onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleGenerateBill}
            disabled={loading}
          >
            {loading ? 'Generating...' : 'Generate'}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default GenerateBillModal
